import React, { memo, useState, useEffect } from "react";
import { withNamespaces } from "react-i18next";
import MessageBox from "src/modules/data-protection/components/MessageBox";
import ReportIncidenService from "../../components/api/ReportIncidenService";
import { useQuery } from "@tanstack/react-query";
import { toast } from "react-toastify";

const MessageComponent = ({ t, caseId, type }) => {
  const [mentionSuggestionList, setMentionSuggestionList] = useState([]);

  const messageSettings = {
    messageListUrl: type === "internal" ? "report.listCommentInternal" : "report.listComment",
    sendMessageUrl: type === "internal" ? "report.addCommentInternal" : "report.addComment",
    attachmentDownloadUrl: "/report/attachment/{attachmentId}/download",
    attachmentUploadUrl: "report.uploadAttachment",
    attachmentDeleteUrl: "attachment",
    payloadId: "report_case_id",
    assetId: caseId,
    mention: {
      enable: true,
      suggestionList: mentionSuggestionList,
    },
  };

  const handleFetchCommunicationMentionSuggestionListQuery = useQuery({
    queryKey: ["fetch-communication-mention-suggestion-list-query"],
    queryFn: async () => {
      const service = new ReportIncidenService();
      return await service.mentionCommentSearch(caseId, {
        query: "",
      });
    },
    cacheTime: 0,
    refetchOnWindowFocus: false,
    onError: (error) => {
      if (process.env.NODE_ENV === "development") console.error(error);
      toast(t("An error occurred while fetching analyst admins list."), {
        type: "error",
      });
    },
  });

  useEffect(() => {
    const { data } = handleFetchCommunicationMentionSuggestionListQuery ?? {};
    if (data && Array.isArray(data)) {
      const list = data.map((item) => ({
        text: item.full_name,
        url: item.id,
        value: item.full_name,
      }));
      setMentionSuggestionList(list);
    }
  }, [handleFetchCommunicationMentionSuggestionListQuery.data]);

  if (
    handleFetchCommunicationMentionSuggestionListQuery.isLoading ||
    handleFetchCommunicationMentionSuggestionListQuery.isFetching ||
    !caseId
  ) {
    return (
      <div className="dt-field dt-skeleton" style={{ width: "100%", height: "320px" }}></div>
    );
  }

  return (
    <MessageBox
      settings={{
        ...messageSettings,
        headerOptions: {
          displayFilters: true,
          title: type === "internal" ? "Internal Communication" : "Contact Person",
        },
      }}
    />
  );
};

export default withNamespaces()(memo(MessageComponent));
